import cn from 'classnames';
import React, { memo, useCallback, useMemo, useState } from 'react';

import ArrowActive from 'assets/icon/arrow-active.svg';
import Arrow from 'assets/icon/arrow.svg';
import Text from 'components/atoms/text';

import sm from './styles.module.scss';

const TEXTS = {
  ALT: {
    BACK: 'Back',
  },
};

interface Props {
  onClick: EmptyArgsVoidFunc;
  label: string;
  withOutMargin?: boolean;
}

type HandleHoverOrLeaveBtn = EmptyArgsVoidFunc;

const BackButton = ({ onClick, label, withOutMargin }: Props) => {
  // region *******************************DATA*********************************
  const [isCursorOnButton, setIsCursorOnButton] = useState(false);
  // endregion

  // region *****************************CALLBACKS******************************
  const handleHoverOrLeaveBtn: HandleHoverOrLeaveBtn = useCallback(() => {
    setIsCursorOnButton((prevState) => !prevState);
  }, []);
  // endregion

  // region ********************************JSX*********************************
  return (
    <button
      onClick={onClick}
      className={useMemo(
        () =>
          cn([sm.Container], {
            [sm.Container_WithOutMargin]: withOutMargin,
          }),
        [withOutMargin]
      )}
      onMouseEnter={handleHoverOrLeaveBtn}
      onMouseLeave={handleHoverOrLeaveBtn}
    >
      <img
        className={sm.Container_Img}
        src={isCursorOnButton ? ArrowActive : Arrow}
        alt={TEXTS.ALT.BACK}
      />
      <Text
        content={label}
        withMediumWeight
        withGreyColor={!isCursorOnButton}
      />
    </button>
  );
  // endregion
};

export default memo(BackButton);
